<template>
  <div style="display: flex;flex-direction: column;align-items: center">
    <frame-form ref="frameFrom" componentParam="bus_waifa_zhijian_record_editForm" :init-data="this.parentData"></frame-form>
    <div style="width: 68%" v-for="(item,index) in this.pdf" :key="item" :id="item">
      <el-label>{{"PDF:"}}</el-label><el-link style="color: #0a84ff" @click="this.startPage(item)">{{this.pdfName[index]}}</el-link>
    </div>
  </div>
</template>

<script>
export default {
  name: "PDFView",
  props: {
    parentData: {
      type: Object,
      default() {
        return {}
      }
    },
  },
  data(){
    return{
      pdf:[],
      pdfName:[]
    }
  },
  methods:{
    async startPage(pdfId) {
      let {data:res} = await this.$axios.post('/doc/getPrcFile', pdfId);
        if (res.code !== 0) {
          return this.$message.error("操作失败");
        }else {
        this.fileData = res.data

        let windowObj = {}
        windowObj.icon = "system/view";
        windowObj.component = "dc/PrcPdf";
        windowObj.name = "PDF查看";
        windowObj.parentData = this.fileData;
        windowObj.height = 600 || this.$store.getters['core/getGlobalWindowHeight']
        windowObj.width = 1100 || this.$store.getters['core/getGlobalWindowWidth']
        windowObj.no_min = true
        windowObj.max = true

        this.$store.dispatch('core/openWindow', windowObj)
      }
    },
  },
  created() {
    let pdfs = this.parentData.pdf.toString()
    this.pdf = pdfs.substring(1,pdfs.length-1).split(",")
    this.pdfName = this.parentData.pdf_name.split(",")
  }
}
</script>

<style scoped>

</style>